<i18n src="./../../i18n/home_page.json"></i18n>

<template>
    <div id="home-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid">
            <navigation-bar :is-on-front-page="true"/>

            <!-- Offer carousel -->
            <offer-carousel v-bind:carouser-data="content.offerCarouselItems" />

            <div class="container pt-4">
                <div class="row">
                    <div class="col text-center">
                        <h2 v-text="$t('news.title')"/>
                    </div>
                </div>
            </div>

            <div class="container pt-4 container-custom">
                <div class="row">
                    <div class="col">
                        <carousel v-if="loaded"
                                :autoplay="true"
                                :nav="false"
                                :margin="20"
                                :loop="true"
                                :dots="true"
                                :autoplayTimeout="6000"
                                :responsiveClass="true"
                                :smartSpeed="2000"
                                :responsive="{0:{items:1},800:{items:2},1200:{items:3}}">

                            <div class="card" v-for="info in content.infoItems" :key="info.title">
                                <router-link :to="{name: 'infoPage', params: {pageName: info.url}}" class="card-img-wrapper">
                                    <img class="lazy card-img-top" :data-src="info.image" :alt="info.imageAlt">
                                </router-link>
                                <div class="card-body">
                                    <router-link :to="{name: 'infoPage', params: {pageName: info.url}}">
                                        <h6 class="card-title pb-0 mb-0" v-text="info.title"/>
                                    </router-link>
                                    <p class="card-text"><small class="text-muted" v-text="info.date"/></p>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>

            <!-- About paralax -->
            <div id="o-firmie" class="mt-5"></div>
            <div id="mt-about-section" class="lazy jumbotron paralax paralax-about-section" data-bg="/assets/mt-about-paralax.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular" v-text="$t('about.title')"/>
                </div>
            </div>

            <!-- About content -->
            <div class="container pt-4">
                <div class="row">
                    <div class="col text-center">
                        <h2 v-text="$t('about.header')"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <h1 class="subtitle mt-c-grey" v-text="$t('about.content')"/>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row pt-4 pb-5">
                    <about-item v-for="item in content.aboutItems"
                                :key="item.title"
                                v-bind:item-data="item"/>
                </div>
            </div>

            <!-- Contact -->
            <div id="kontakt" class="mt-5"></div>
            <main-map :map-data="content.departmentItems"/>

            <!-- Footer -->
            <div class="container-fluid mt-contact-section">
                <div class="lazy container-fluid">
                    <div class="text-center pt-4">
                        <router-link :to="{name: 'contact'}">
                            <button type="button" class="btn btn-secondary btn-lg mt-button mt-button-secondary mt-button-border ml-3 mr-3 mt-2 pl-5 pr-5">{{ $t('contact.title') }} <font-awesome-icon class="" icon="angle-double-right"/></button>
                        </router-link>
                    </div>
                    <div class="pt-5 pb-5">
                        <div class="pt-5 mt-4 mb-5 text-center">
                            <h2 v-text="$t('contact.header')"/>
                        </div>
                    </div>
                    <contact-form/>

                    <div class="container">
                        <main-footer/>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import OfferCarousel from "@/components/home/OfferCarousel";
    import $ from 'jquery'
    import AboutItem from "@/components/home/AboutItem";
    import ContactForm from "@/components/commons/ContactForm";
    import MainFooter from "@/components/commons/MainFooter";
    import LazyLoad from "vanilla-lazyload";
    import axios from 'axios'
    import carousel from 'vue-owl-carousel'
    import MainMap from "../commons/MainMap";

    var lazyLoadInstance = new LazyLoad({
        threshold: 0,
        elements_selector: ".lazy",
        callback_loaded: function (element) {
            if (element.className.indexOf("card-img-top") > -1) {
                let nextElement = element.closest(".owl-item").nextElementSibling;
                if (nextElement) {
                    lazyLoadInstance.load(nextElement.getElementsByClassName("card-img-top")[0])
                }
            }
        }
    });

    export default {
        name: "HomePage",
        components: {MainMap, MainFooter, ContactForm, AboutItem, OfferCarousel, NavigationBar, carousel},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path,
                slickOptions: {
                    slidesToShow: 3,
                }
            }
        },
        mounted() {
            axios.get(`${Const.API_HOST}/${this.locale}/content/home`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true
                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });

            $(document).scroll(function () {
                var $nav = $(".navbar-light");
                $nav.removeClass('initial');
                $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
        }
    }
</script>

<style scoped>

    .mt-contact-section > .container-fluid {
        background-image: linear-gradient(to top, transparent 0%, transparent 600px, #91A7BD 600px, #91A7BD 606px, #C9D3DE 606px, #C9D3DE 612px, white 612px, white 100%);
    }

    @media (max-width: 768px) {
        .mt-contact-section > .container-fluid {
            background-image: linear-gradient(to top, transparent 0%, transparent 1280px, #91A7BD 1280px, #91A7BD 1286px, #C9D3DE 1286px, #C9D3DE 1292px, white 1292px,  white 100%);
        }
    }

    .content-container {
        margin-bottom: 0;
    }

    .subtitle {
      font-size: 1rem;
    }

    @media (min-width: 1600px) {
        .container-custom {
            max-width: 1520px;
        }
    }

    .card {
        border-radius: 0;
    }

    .card-body {
        padding: 0.7rem;
    }

    .card-title {
        line-height: 1.2rem;
        height: 2.4rem;
        overflow: hidden;
    }

    .card-img-wrapper {
        height: 25vh;
    }

    .card-img-wrapper img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .paralax {
        min-height: 300px;
        background-attachment: fixed;
        background-size: cover;
        background-position: 50% 50%;
        opacity: 0.75;
        filter: alpha(opacity=75);
        z-index: 1;
    }

    .paralax p, .mt-carousel-offer-text p {
        color: #000;
        opacity: 0.50;
        filter: alpha(opacity=60);
        padding-top: 265px;
        line-height: 0;
        text-align: right;
    }

    @media (max-width: 768px) {
        .paralax p {
            padding-top: 276px;
            font-size: 4rem;
        }
    }

    .card:hover {
        box-shadow: 0 0 30px -15px rgba(0, 0, 0, 0.2);
        transition: box-shadow 0.1s ease-in-out;
    }
</style>